import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles(() =>
  createStyles({
    disabled: {
      opacity: 0.5,
      pointerEvents: 'none',
    },
  })
);

type Props = {
  disabled?: boolean;
  children: React.ReactNode;
};

const Disabled: React.FC<Props> = ({ disabled, children }) => {
  const classes = useStyle();

  return <Box className={disabled ? classes.disabled : ''}>{children}</Box>;
};

export default Disabled;
